<template>
    <div>
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group">
                    <label>
                        <localized-text localizedKey="Nome (fatturazione)" text="Nome (fatturazione)"></localized-text>
                    </label>
                    <span class="form-control" v-if="readonly">
                        {{localValue.name}}
                    </span>
                    <input type="text" class="form-control" v-model="localValue.name" v-else />
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label>
                        <localized-text localizedKey="Cognome (fatturazione)" text="Cognome (fatturazione)"></localized-text>
                    </label>
                    <span class="form-control" v-if="readonly">
                        {{localValue.surname}}
                    </span>
                    <input type="text" class="form-control" v-model="localValue.surname" v-else />
                </div>
            </div>
        </div>
        <div class="form-group">
            <label>
                <localized-text localizedKey="Sesso" text="Sesso"></localized-text>
            </label>
            <span class="form-control" v-if="readonly">
                {{localValue.sex}}
            </span>
            <div v-else>
                <button class="btn btn-link" :class="{ active: localValue.sex == 'M'}" @click="localValue.sex = 'M'">
                    <localized-text localizedKey="Maschio" text="Maschio"></localized-text>
                </button>
                <button class="btn btn-link" :class="{ active: localValue.sex == 'F'}" @click="localValue.sex = 'F'">
                    <localized-text localizedKey="Femmina" text="Femmina"></localized-text>
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group">
                    <label>
                        <localized-text localizedKey="Codice Fiscale" text="Codice Fiscale"></localized-text>
                    </label>
                    <span class="form-control" v-if="readonly">
                        {{localValue.fiscalCode}}
                    </span>
                    <input type="text" class="form-control" v-model="localValue.fiscalCode" v-else />
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label>
                        <localized-text localizedKey="Partita iva" text="Partita iva"></localized-text>
                    </label>
                    <div>
                        <toggler :readonly="readonly" v-model="localValue.hasVat"></toggler>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="localValue.hasVat">
            <div class="row">
                <div class="form-group col-md-4">
                    <label>
                        <localized-text localizedKey="Ragione sociale" text="Ragione sociale"></localized-text>
                    </label>
                    <span class="form-control" v-if="readonly">
                        {{localValue.companyName}}
                    </span>
                    <input type="text" class="form-control" v-model="localValue.companyName" v-else />
                </div>
                <div class="form-group col-md-4">
                    <label>
                        <localized-text localizedKey="Numero partita iva" text="Numero partita iva"></localized-text>
                    </label>
                    <span class="form-control" v-if="readonly">
                        {{localValue.vatNumber}}
                    </span>
                    <input type="text" class="form-control" v-model="localValue.vatNumber" v-else />
                </div>
                <div class="form-group col-md-4">
                    <label>
                        <localized-text localizedKey="Codice destinatario" text="Codice destinatario"></localized-text>
                    </label>
                    <span class="form-control" v-if="readonly">
                        {{localValue.codiceDestinatario}}
                    </span>
                    <input type="text" class="form-control" v-model="localValue.codiceDestinatario" v-else />
                </div>
                <div class="form-group col-md-4">
                    <label>
                        <localized-text localizedKey="Pec" text="Pec"></localized-text>
                    </label>
                    <span class="form-control" v-if="readonly">
                        {{localValue.pec}}
                    </span>
                    <input type="text" class="form-control" v-model="localValue.pec" v-else />
                </div>
            </div>
        </template>
        <div class="row">
            <div class="form-group col-md-4">
                <label>
                    <localized-text localizedKey="Data di nascita" text="Data di nascita"></localized-text>
                </label>
                <span class="form-control" v-if="readonly">
                    {{$filters.date(localValue.birthDate)}}
                </span>
                <op-date class="form-control" v-model="localValue.birthDate" v-else></op-date>
            </div>
            <div class="form-group col-md-8">
                <label>
                    <localized-text localizedKey="Luogo nascita" text="Luogo nascita"></localized-text>
                </label>
                <span class="form-control" v-if="readonly">
                    {{localValue.birthPlace}}
                </span>
                <input type="text" class="form-control" v-model="localValue.birthPlace" v-else />
            </div>
        </div>
        <op-address :readonly="readonly" v-model="localValue.fiscalAddress" :label="$localizationService.GetLocalizedValue('Indirizzo di fatturazione', 'Indirizzo di fatturazione')"></op-address>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model'
import { mixins, Options, Vue } from 'vue-class-component';
import WithModel from '@/mixins/withModel';
import { ModalServices } from '@/services/ModalServices';
import { LocalizationServices } from '@/services/LocalizationServices';
import * as utils from '@/utils';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class fiscalData extends mixins(WithModel) {

    @Prop() user: OM.BaseUser;
    @Prop() readonly: boolean;

    declare localValue: OM.FiscalData;
    codFiscError: boolean = false;
    codFiscNonCoerente: boolean = false;
    
    checkValidityCodiceFiscale(){
        this.$store.state.formErrors.codiceFiscale = false;
        this.codFiscError = false;
        try {
            let inverso = utils.CodFiscInverso(this.localValue.fiscalCode);
            this.localValue.birthDate = new Date(inverso.year, inverso.month - 1, inverso.day).toISOString();
            this.user.fiscalData.sex = inverso.gender;
            this.localValue.birthDate = inverso.birthplace;
            
            let calculated = utils.CalcolaCodFisc(this.user.personalData.name, this.user.personalData.surname, (<any>this.user.fiscalData.sex), inverso.day, inverso.month, inverso.year, inverso.birthplace, inverso.birthplaceProvincia);
            if(calculated.cf == inverso.cf){
                this.$store.state.formErrors.codiceFiscale = false;
                this.codFiscNonCoerente = false;
            } else {
                this.$store.state.formErrors.codiceFiscale = true;
                this.codFiscNonCoerente = true;
            }
        } catch(ex){
            this.codFiscError = true;
            this.$store.state.formErrors.codiceFiscale = true;
        }
    }

    alertLuogoDataNascita(){
        ModalServices.alertModal(
            '',
            LocalizationServices.GetLocalizedValue('Luogo e data di nascita vengono compilati tramite il codice fiscale', 'Luogo e data di nascita vengono compilati tramite il codice fiscale')
        )
    }

}
</script>
<style scoped>
</style>
